<template>
  <el-container>
    <el-col>
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <quote></quote>
        </el-col>
        <el-col :md="12" :lg="12" :xl="12" style="height:100%;">
          <authortop :count="2" url="most"></authortop>
        </el-col>
      </el-row>

      <h1>Top Quoturs</h1>
      <el-divider></el-divider>
      <authortop url="top"></authortop>
    </el-col>
  </el-container>
</template>
<script>
// import { mapMutations } from "vuex";
import quote from "./RandQ.vue";
import authortop from "./AuthorTop";
import nav from "../mixins/nav";
export default {
  components: { quote, authortop },
  data() {
    return {};
  },
  mixins: [nav],
  name: "helloworld",
  methods: {}
};
</script>
<style scoped></style>
